class AuthConfigData {
	constructor(data) {
		this.data = data;
		this.host = data.host;
		this.region = data.region;
		this.clientId = data.clientId;
		this.userPoolId = data.userPoolId;
		this.authFlowType = data.authFlowType;
	}

	get redirectUrl() {
		return window.location.origin;
	}

	get loginUrl() {
		return this.host + "/login?client_id=" + this.clientId + "&redirect_uri=" + this.redirectUrl + "&response_type=code";
	}

	get scopes() {
		return this.host + "/access";
	}

	get tokenUrl() {
		return this.host + "/oauth2/token";
	}

	get userinfoUrl() {
		return this.host + "/oauth2/userInfo";
	}

	get logoutUrl() {
		return this.host + "/logout";
	}
}
const AuthConfig = new AuthConfigData(__AUTH_CONFIG); // eslint-disable-line
export default AuthConfig;
